const ProgressBarBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22"
    viewBox="0 0 24 22"
  >
    <path fill="#333" d="M0 0h24v2H0z" />
    <path fill="#ffd400" d="M0 2h22v2H0z" />
    <path fill="#333" d="M0 6h22v2H0z" />
    <path fill="#ffd400" d="M0 8h20v2H0z" />
    <path fill="#333" d="M0 12h20v2H0z" />
    <path fill="#ffd400" d="M0 14h18v2H0z" />
    <path fill="#333" d="M0 18h18v2H0z" />
    <path fill="#ffd400" d="M0 20h16v2H0z" />
  </svg>
);

export default ProgressBarBlockIcon;
